<template>
<div class="chapter">
<div class="inner_page">
<div epub:type="bodymatter">
<h1 class="part" id="_idParaDest-7"><span class="partNum"><a id="_idTextAnchor006"></a>Part One</span></h1>
<h1 class="chp" id="_idParaDest-10">Horseman</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Headhunter-7.vue?6725e74c